import React from 'react';
import './recovery.css';

export default function RecoveryNotice({ title = 'This page could not be displayed', message, onRetry, retrying = false, children }) {
  return <main className="recovery-shell"><section className="recovery-card" role="alert" aria-labelledby="page-recovery-title">
    <span className="recovery-mark" aria-hidden="true">!</span>
    <h1 id="page-recovery-title">{title}</h1>
    <p>{message}</p>
    {children}
    {onRetry && <button className="recovery-button" type="button" disabled={retrying} onClick={onRetry}>{retrying ? 'Trying again…' : 'Try again'}</button>}
  </section></main>;
}
